<template>
  <div>
    <div class="grid-content">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>员工模块</el-breadcrumb-item>
        <el-breadcrumb-item>员工详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row :gutter="0" class="grid-content">
      <el-col :span="12">
        <div class="inputDiv">
          <div class="inputLeft">登陆账号：</div>
          <el-input
            v-model="user.username"
            :disabled="true"
            style="width: unset;"
            placeholder="请输入登陆账号"
          ></el-input>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">员工姓名：</div>
          <el-input
            v-model="user.name"
            :disabled="inputDisabled"
            style="width: unset;"
            placeholder="请输入员工名称"
          ></el-input>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">员工电话：</span>
          <el-input
            v-model="user.tel"
            :disabled="inputDisabled"
            class="inputRight"
            style="width: unset;"
            placeholder="请输入员工电话"
          ></el-input>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">部门：</div>
          <!-- <el-date-picker
            v-model="user.deptName"
            type="date"
            style="width:200px"
            value-format="yyyy-MM-dd"
          placeholder="选择日期"></el-date-picker>-->
          <el-select
            v-model="user.deptId"
            :disabled="inputDisabled"
            style="width:200px"
            placeholder="请选择员工部门"
          >
            <el-option
              v-for="item in deptList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">生日：</div>
          <el-date-picker
            v-model="user.birthday"
            type="date"
            :disabled="inputDisabled"
            style="width:200px"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">性别：</span>
          <el-select
            v-model="user.gender"
            :disabled="inputDisabled"
            style="width:200px"
            placeholder="请选择员工性别"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">地址：</div>
          <el-input v-model="address.province" class="inputdi" :disabled="true" placeholder="省"></el-input>
          <el-input v-model="address.city" class="inputdi" :disabled="true" placeholder="市"></el-input>
          <el-input v-model="address.county" class="inputdi" :disabled="true" placeholder="区"></el-input>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">详细地址：</div>
          <el-input
            v-model="user.address"
            :disabled="inputDisabled"
            class="inputRight"
            type="textarea"
            :rows="2"
            style="width: unset;"
            placeholder="请输入详细地址"
          ></el-input>
        </div>
        <div class="inputDiv">
          <el-button type="primary" @click="onEdit" class="widthButton">
            {{
            edit
            }}
          </el-button>
          <el-button class="widthButton" @click="back">取消</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { userMod } from "@/api/uesr";
import { deptSel } from "@/api/department";
export default {
  data() {
    return {
      inputDisabled: true,
      edit: "编辑",
      address: {
        province: localStorage.getItem("province"),
        city: localStorage.getItem("city"),
        county: localStorage.getItem("county")
      },
      user: {
        username: "",
        name: "",
        pass: "",
        tel: "",
        gender: "",
        deptId:"",
        birthday: "",
        address: ""
      },
      options: [
        {
          value: 1,
          label: "男"
        },
        {
          value: 2,
          label: "女"
        }
      ],
      deptList : []
    };
  },
  mounted() {
    this.user = this.$route.query;
    this.getDeptList()
  },
  methods: {
    onEdit() {
      if (this.inputDisabled) {
        this.inputDisabled = false;
        this.edit = "确定";
      } else {
        userMod(this.user)
          .then(res => {
            if (res.count == 1) {
              this.inputDisabled = true;
              this.edit = "编辑";
              this.$message({
                type: "success",
                message: "修改成功!"
              });
              this.back();
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    back() {
      this.$router.go(-1);
    },
        getDeptList(){
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        states: 1,
        pageNum: 1,
        pageSize: 500
      };
      deptSel(params)
        .then(res => {
          this.deptList = [];
          res.gridData.forEach(element => {
            //element.state = getBatchStates(element.progress);
            const deptData = {
              value:element.id,
              label:element.name,
            }
            this.deptList.push(deptData);
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style></style>
